import { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import { FaChevronDown } from 'react-icons/fa';
import { BsChat } from 'react-icons/bs';
import {
    getOpenWidgetBtnPosition,
    isValidPrice,
    getWidgetPosition,
    applyImportantStyles,
} from '../../../lib';
import * as constants from './../../../constants';

import './ToggleWidgetRoundBtn.css';

const ToggleWidgetRoundBtn = ({
    chatBtnOnClick,
    toggleWidgetRoundBtn,
    toggleWidget,
    widgetPosition,
    showWidget,
    enableXBtn,
    ourPrice,
    showOnlyWhenClosed = false,
    showCta = true,
}) => {
    // TODO: NEED TO REFACTOR THIS ONLY PASS THE PRICE THAT WE WANT TO DISPLAY??
    const isOpen = useSelector((state) => state.miniBookingWidget.open);
    const price = useSelector((state) => state.miniBookingWidget.price);
    const widgetVariant =
        useSelector((state) => state.miniBookingWidget?.data?.smallWidget) ||
        constants.SMALL;

    const messageNextToWidget = useSelector(
        (state) => state.miniBookingWidget?.data?.messageNextToWidget
    );

    // TODO: REFACTOR THIS
    const [displayCta, setDisplayCta] = useState(
        (widgetVariant === constants.REGULAR ||
            widgetVariant === constants.HORIZONTAL) &&
            showCta
    );
    const [isMessageVisible, setIsMessageVisible] = useState(false);
    const hasTwoWidgets = widgetVariant === 'widget&click2call';

    let openWidgetButtonStyles = getOpenWidgetBtnPosition(
        widgetPosition?.position
    );
    const isBottomRight = widgetPosition.position === 'bottom-right';
    const btnContainerStyles = widgetPosition?.position?.includes('left')
        ? { marginLeft: 0 }
        : { marginLeft: 'auto' };

    if (toggleWidgetRoundBtn) {
        openWidgetButtonStyles = {
            ...openWidgetButtonStyles,
            backgroundColor: toggleWidgetRoundBtn.backgroundColor,
            color: toggleWidgetRoundBtn.color,
        };
    }
    const toKebab = (s) => s.replace(/([A-Z])/g, '-$1').toLowerCase();

    const kebabOpen = Object.fromEntries(
        Object.entries(openWidgetButtonStyles || {}).map(([k, v]) => [
            toKebab(k),
            v,
        ])
    );

    const closeBtnStyle = {
        ...kebabOpen,
        'margin-left': kebabOpen['margin-left'] ?? 'auto',
        'background-color': kebabOpen['background-color'] ?? '#545454',
    };
    if (hasTwoWidgets) {
        openWidgetButtonStyles = {
            ...openWidgetButtonStyles,
            width: 70,
            height: 70,
        };
    }

    const handleCloseMessage = (event) => {
        event.stopPropagation();
        setIsMessageVisible(false);
        const expiryTime = Date.now() + 5 * 60 * 1000; // 5 minutes from now
        localStorage.setItem(
            'widgetMessageClosedAt',
            JSON.stringify(expiryTime)
        );
    };
    useEffect(() => {
        const storedExpiryTime = localStorage.getItem('widgetMessageClosedAt');
        if (storedExpiryTime) {
            const expiryTime = JSON.parse(storedExpiryTime);
            const currentTime = Date.now();

            if (currentTime > expiryTime) {
                localStorage.removeItem('widgetMessageClosedAt');
                setIsMessageVisible(true);
            } else {
                setIsMessageVisible(false);
            }
        } else {
            setIsMessageVisible(true);
        }
    }, []);

    const useLoyaltyPrice = isValidPrice(ourPrice?.loyaltyprice);
    let priceToDisplay;
    if (hasTwoWidgets) {
        priceToDisplay = useLoyaltyPrice
            ? Math.floor(ourPrice?.loyaltyprice)
            : Math.floor(price);
    } else {
        priceToDisplay = useLoyaltyPrice ? ourPrice?.loyaltyprice : price;
    }
    if (!toggleWidgetRoundBtn) {
        return null;
    }
    const widgetPositionStyles = getWidgetPosition(widgetPosition);
    const bottomValue = parseInt(widgetPositionStyles.bottom);
    const rightValue = parseInt(widgetPositionStyles.right);
    const msgPositionStyles = {
        bottom: bottomValue + 10,
        right: rightValue + 75,
    };

    const minPriceBtn = useRef(null);

    useEffect(() => {
        if (displayCta) {
            setTimeout(() => {
                if (minPriceBtn.current) {
                    minPriceBtn.current.classList.add('no-cta');
                    setTimeout(() => {
                        setDisplayCta(false);
                    }, 4500);
                }
            }, 2000);
        }
    }, [isOpen]);
    return (
        <>
            {showOnlyWhenClosed && isOpen ? null : (
                <>
                    {isMessageVisible && messageNextToWidget && (
                        <div
                            className={`message-container ${
                                isBottomRight ? 'bottom-right' : ''
                            }`}
                            onClick={toggleWidget}
                            style={{
                                ...btnContainerStyles,
                                ...(hasTwoWidgets ? msgPositionStyles : {}),
                            }}
                        >
                            <span
                                className="message"
                                style={closeBtnStyle}
                                dangerouslySetInnerHTML={{
                                    __html: messageNextToWidget,
                                }}
                            ></span>
                            <button
                                className="close-button"
                                style={closeBtnStyle}
                                onClick={handleCloseMessage}
                                ref={(el) => {
                                    applyImportantStyles(el, closeBtnStyle);
                                }}
                            >
                                &times;
                            </button>
                        </div>
                    )}

                    <div
                        className="ab-button-container"
                        style={btnContainerStyles}
                    >
                        <div
                            className={`ab-min-price-btn ab-open-widget-btn ${
                                displayCta ? 'ab-min-price-btn-cta' : ''
                            }`}
                            onClick={toggleWidget}
                            style={openWidgetButtonStyles}
                            ref={minPriceBtn}
                        >
                            {isOpen && !displayCta ? (
                                <FaChevronDown size={28} />
                            ) : (
                                <>
                                    {priceToDisplay ? (
                                        <>
                                            {displayCta &&
                                                toggleWidgetRoundBtn?.btnText && (
                                                    <div className="ab-cta">
                                                        {
                                                            toggleWidgetRoundBtn?.btnText
                                                        }
                                                    </div>
                                                )}

                                            <div className="ab-min-price-btn-cnt">
                                                <span className="price">
                                                    {priceToDisplay}{' '}
                                                    <sup className="currency-sign">
                                                        {
                                                            ourPrice?.currencySymbol
                                                        }
                                                    </sup>
                                                </span>
                                                <span className="nights">
                                                    {ourPrice?.nights}{' '}
                                                    {ourPrice?.nightsText}
                                                </span>
                                            </div>
                                        </>
                                    ) : (
                                        <span className="price">
                                            {ourPrice?.text}
                                        </span>
                                    )}
                                    {enableXBtn && (
                                        <button
                                            className="ab-close-widget-btn"
                                            onClick={() => showWidget(false)}
                                        >
                                            <FaChevronDown size={12} />
                                        </button>
                                    )}
                                </>
                            )}
                        </div>
                        {toggleWidgetRoundBtn?.chatEnabled && (
                            <div
                                className="ab-chat-btn"
                                onClick={chatBtnOnClick}
                                style={openWidgetButtonStyles}
                            >
                                <BsChat size={20} />
                            </div>
                        )}
                    </div>
                </>
            )}
        </>
    );
};

ToggleWidgetRoundBtn.propTypes = {
    chatBtnOnClick: PropTypes.func,
    toggleWidgetRoundBtn: PropTypes.object,
    toggleWidget: PropTypes.func.isRequired,
    widgetPosition: PropTypes.object,
    showWidget: PropTypes.func.isRequired,
    enableXBtn: PropTypes.bool,
    ourPrice: PropTypes.object,
    showOnlyWhenClosed: PropTypes.bool,
    showCta: PropTypes.bool,
};

export default ToggleWidgetRoundBtn;
